import { render, staticRenderFns } from "./GetPedidos.vue?vue&type=template&id=0c65a3ce&"
import script from "./GetPedidos.vue?vue&type=script&lang=js&"
export * from "./GetPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports